import * as React from "react";

import type { useModalProvider } from "@hooks/modal/useModalManager";

export const ModalContext = React.createContext<ReturnType<
  typeof useModalProvider
> | null>(null);
